import axios from 'axios';
import { FornecedorSap } from '@models/fornecedor-sap.model';
import { CriaFornecedorSapDto } from '@/../../back/src/fornecedores-sap/dto/cria-fornecedor-sap.dto';
import { AtualizaFornecedorSapDto } from '@/../../back/src/fornecedores-sap/dto/atualiza-fornecedor-sap.dto';
import { PedidoSap } from '@models/pedido-sap.model';

const listaFornecedoresSap = async (): Promise<FornecedorSap[]> => {
  const res = await axios.get<FornecedorSap[]>(`/fornecedores_sap`);
  return res.data;
};
const listaPedidosPorFornecedor = async (
  fornecedorSapId: number,
): Promise<PedidoSap[]> => {
  const res = await axios.get<PedidoSap[]>(
    `/fornecedores_sap/${fornecedorSapId}/pedidos_sap`,
  );
  return res.data;
};

const cria = async (formData: CriaFornecedorSapDto): Promise<FornecedorSap> => {
  const res = await axios.post<FornecedorSap>('/fornecedores_sap', formData);
  return res.data;
};

const busca = async (fornecedorSapId: number): Promise<FornecedorSap> => {
  const res = await axios.get<FornecedorSap>(
    `/fornecedores_sap/${fornecedorSapId}`,
  );
  return res.data;
};

const atualiza = async (
  fornecedorSapId: number,
  formData: AtualizaFornecedorSapDto,
): Promise<FornecedorSap> => {
  const res = await axios.patch<FornecedorSap>(
    `/fornecedores_sap/${fornecedorSapId}`,
    formData,
  );
  return res.data;
};

const remove = async (fornecedorSapId: number): Promise<FornecedorSap> => {
  const res = await axios.delete<FornecedorSap>(
    `/fornecedores_sap/${fornecedorSapId}`,
  );
  return res.data;
};

export default {
  listaFornecedoresSap,
  listaPedidosPorFornecedor,
  cria,
  busca,
  atualiza,
  remove,
};
